import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PaginationNavigationButton } from './private/PaginationNavigationButton';
import { PaginationPages } from './private/PaginationPages';

interface PaginationProps {
  children: ReactElement<unknown> | ReactElement<unknown>[];
  pagesCount: number;
  currentPage: number;
  long?: boolean;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  onPreviousMouseOver?: () => void;
  onNextMouseOver?: () => void;
}

export function Pagination({
  children,
  currentPage,
  long = false,
  pagesCount = 0,
  onPreviousClick,
  onNextClick,
  onPreviousMouseOver,
  onNextMouseOver,
}: PaginationProps) {
  const { t } = useTranslation('ui');

  if (pagesCount <= 1) return null;

  return (
    <nav role="navigation" aria-label="pagination navigation">
      <ul className="flex select-none">
        <PaginationNavigationButton
          disabled={currentPage === 1}
          icon="chevron-left-large"
          label={t('previousPage')}
          onClick={onPreviousClick}
          onMouseOver={onPreviousMouseOver}
        />
        <PaginationPages
          currentPage={currentPage}
          pagesCount={pagesCount}
          visiblePagesCount={long ? 12 : 5}
        >
          {children}
        </PaginationPages>
        <PaginationNavigationButton
          disabled={currentPage === pagesCount}
          icon="chevron-right-large"
          label={t('nextPage')}
          onClick={onNextClick}
          onMouseOver={onNextMouseOver}
        />
      </ul>
    </nav>
  );
}

export default Pagination;
